export default "__VITE_ASSET__CY8gP7pm__"